import React from "react";
import { Route, Routes } from "react-router-dom";
import Invitation from "../pages/unauth/invitation/Invitation";
import NoPage from "../pages/auth/NoPage/NoPage";
import HomeScreen from "../pages/unauth/home/HomeScreen";
import Login from "../pages/unauth/login/Login";
import ServerTimeout from "../pages/unauth/serverTimeout/ServerTimeout";
import B2CLayout from "./B2CLayout";

export default function UnAuthLayout() {
  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={
            <B2CLayout>
              <HomeScreen />
            </B2CLayout>
          }
        />
        <Route path="admin-login" element={<Login />} />
        <Route path="invitation/:couple/:date" element={<Invitation />} />
        <Route path="server-timeout" element={<ServerTimeout />} />
        <Route path="*" element={<NoPage />} />
      </Route>
    </Routes>
  );
}
